import { render, staticRenderFns } from "./CTQAnalyzer.vue?vue&type=template&id=70712cd2"
import script from "./CTQAnalyzer.vue?vue&type=script&lang=js"
export * from "./CTQAnalyzer.vue?vue&type=script&lang=js"
import style0 from "./CTQAnalyzer.vue?vue&type=style&index=0&id=70712cd2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports